export default "__VITE_ASSET__CfGF2gD7__"